import Swiper from "swiper";
import navigation from "swiper/modules/navigation.min.mjs";
import autoplay from "swiper/modules/autoplay.min.mjs";
import barba from "@barba/core";

import "swiper/swiper.scss";
import "swiper/modules/navigation.scss";

class Gallery {
  constructor() {
    //
  }
  init () {
    const that = this
    this.swiper = new Swiper(".gallery-swiper", {
      modules: [navigation, autoplay],
      loop: true,
      autoplay: false,
      navigation: {
        enabled: true,
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
    });
  }
}

export default new Gallery()

